import { DropdownPopover, IconSearch16, Input, Outside } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './LocationPickerHeader.css';
import { LocationPickerDropdown } from '../LocationPickerDropdown';
import { useEventCallback } from '@cian/react-utils';
import { ISuggestion } from '../../types';

interface ILocationPickerHeaderProps {
  query: string;
  suggestions: ISuggestion[];
  onSearch(query: string): void;
  onSelect(locationId: number): void;
}

export const LocationPickerHeader: React.FC<ILocationPickerHeaderProps> = ({
  query,
  suggestions,
  onSearch,
  onSelect,
}) => {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const contentRef = React.useRef<HTMLDivElement>(null);

  const [open, setOpen] = React.useState(false);

  const handleSearch = useEventCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    onSearch(e.target.value);
  });

  return (
    <Outside onOutside={() => setOpen(false)} insideRefs={[inputRef, contentRef]}>
      <DropdownPopover
        open={open && Boolean(query)}
        content={<LocationPickerDropdown ref={contentRef} suggestions={suggestions} onSelect={onSelect} />}
      >
        <Input
          data-name="LocationPickerInput"
          ref={inputRef}
          width={435}
          onChange={handleSearch}
          value={query}
          onFocus={() => setOpen(true)}
          placeholder="Название области, края, республики"
          leftAdornment={
            <div className={styles['search-icon']}>
              <IconSearch16 color="primary_100" display="block" />
            </div>
          }
        />
      </DropdownPopover>
    </Outside>
  );
};
